import React from "react";
import styled from "styled-components";

/* Discontinued Typography 
- use LfHeadline or Headline 
*/

const StyledTitleText = styled.h1`
  font-family: ${({ theme }) => theme.fonts.graphik};
  color: ${({ theme, white }) =>
    white ? theme.colors.white : theme.colors.gray1200};
  font-weight: 500;
  font-size: ${({ theme }) => (theme.media.tabletUp ? "3rem" : "2rem")};
  line-height: ${({ theme }) => (theme.media.tabletUp ? "3.5rem" : "2.5rem")};
  margin: 0;
`;

const TitleTxt = ({ children, className, white }) => {
  return (
    <StyledTitleText white={white} className={className}>
      {children}
    </StyledTitleText>
  );
};

TitleTxt.defaultProps = {
  white: false
};

export default TitleTxt;
